module.exports = __webpack_public_path__ + "static/media/android.4eaab2df.png";